var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LaunchIcon from '@mui/icons-material/Launch';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openNewFeaturePopperDialog } from 'store/actions/base/new-feature-popper.actions';
var LearnMoreInfoLink = function (_a) {
    var link = _a.link, newFeatureId = _a.newFeatureId, linkText = _a.linkText, addClassName = _a.addClassName;
    var t = useTranslation().t;
    var anchorRef = useRef(null);
    var dispatch = useDispatch();
    useEffect(function () {
        if (anchorRef.current && newFeatureId) {
            dispatch(openNewFeaturePopperDialog({
                anchorEl: anchorRef.current,
                newFeatureId: newFeatureId
            }));
        }
    }, []);
    return (_jsxs("div", __assign({ className: "flex flex-row space-x-5 items-center text-12", ref: anchorRef }, { children: [_jsx("a", __assign({ href: link, target: "_blank", className: addClassName ? 'text-mainYellow hover:underline' : 'hover:underline' }, { children: linkText ? t(linkText) : t('Узнать больше') }), void 0), _jsx(LaunchIcon, { className: "h-16 w-16 show-full-info-button xs:mr-8 md:mr-12 ", color: "primary" }, void 0)] }), void 0));
};
export default LearnMoreInfoLink;
